import { Components, Theme } from '@mui/material/styles';
import { radii } from '../foundations/tokens';

export const MuiPaper: Components<Theme>['MuiPaper'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: radii.lg,
      backgroundImage: 'none',
      backgroundColor: theme.palette.background.paper,
    }),
    elevation: ({ theme, ownerState }) => ({
      boxShadow: ownerState.elevation
        ? theme.palette.studio.shadows.panel
        : 'none',
    }),
  },
  variants: [
    {
      props: { variant: 'bare' },
      style: ({ theme }) => ({
        background: 'transparent',
        border: 0,
        boxShadow: 'none',
        borderRadius: 0,
        '&:hover': {
          backgroundColor: theme.palette.studio.surfaces.fillSubtle,
        },
        '&:focus-visible': {
          outline: `2px solid ${theme.palette.primary.main}`,
          outlineOffset: -2,
        },
      }),
    },
    {
      props: { variant: 'upload' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.studio.surfaces.fillFaint,
        border: `2px dashed ${theme.palette.studio.borders.dashed}`,
        boxShadow: 'none',
        opacity: 0.72,
        color: theme.palette.text.secondary,
        '&:hover:not([aria-disabled="true"]), &:focus-visible': {
          borderColor: theme.palette.primary.main,
          backgroundColor: theme.palette.studio.surfaces.fillWeak,
          color: theme.palette.primary.main,
          opacity: 1,
        },
        '&:focus-visible': {
          outline: `2px solid ${theme.palette.primary.main}`,
          outlineOffset: 2,
        },
        '&[aria-disabled="true"]': { opacity: 0.4 },
      }),
    },
    {
      props: { variant: 'panel' },
      style: ({ theme }) => ({
        border: `1px solid ${theme.palette.divider}`,
        boxShadow: theme.palette.studio.shadows.panel,
      }),
    },
    {
      props: { variant: 'inset' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.studio.surfaces.fillSubtle,
        border: `1px solid ${theme.palette.studio.borders.subtle}`,
        boxShadow: theme.palette.studio.shadows.controlInset,
      }),
    },
    {
      props: { variant: 'interactive' },
      style: ({ theme }) => ({
        background: theme.palette.studio.surfaces.cardGradientSoft,
        border: `1px solid ${theme.palette.studio.borders.card}`,
        boxShadow: theme.palette.studio.shadows.cardFlat,
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        '&:hover': {
          borderColor: theme.palette.studio.borders.control,
          boxShadow: theme.palette.studio.shadows.card,
        },
        '&:focus-visible': {
          outline: `2px solid ${theme.palette.primary.main}`,
          outlineOffset: 2,
        },
      }),
    },
    {
      props: { variant: 'hero' },
      style: ({ theme }) => ({
        background: theme.palette.background.paper,
        border: `1px solid ${theme.palette.studio.borders.card}`,
        boxShadow: theme.palette.studio.shadows.screen,
        borderRadius: radii['3xl'],
      }),
    },
  ],
};
